<h4 class="mobile-nav-title mb-2" i18n>Customers</h4>
<div *ngIf="customer" class="container-fluid">
  <mat-tab-group [(selectedIndex)]="customerTabIndex">
    <mat-tab label="Customer Info" i18n-label>
      <app-customer-info-mobile [customerObject]="customer" (updated)="customerUpdated($event)"></app-customer-info-mobile>
    </mat-tab>
    <mat-tab label="Quotes" i18n-label>
      <div class="mt-2">
        <h4 class="d-inline mr-3">{{customer.customer_BusinessName}}</h4>
        <a href="http://maps.google.com/?q={{customer.customer_Address1}},{{customer.customer_City}}%20{{customer.customer_State}}%20{{customer.customer_Postal}}" target="_blank"
           class="btn btn-bidit-navigate float-right" i18n>Map Customer</a>
      </div>
      <h5 class="mb-2" i18n>Projects</h5>
      <div class="content">
        <div class="mb-3">
          <app-customer-info-summary-mobile [customerInfo]="customer"></app-customer-info-summary-mobile>
        </div>
        <div *ngIf="customer.quotes.length==0">
          <h5 i18n>No projects exist for this customer</h5>
        </div>
        <div *ngFor="let quote of customer.quotes">
          <div class="card border-bidit-dark bg-light mb-3 shadow">
            <div class="card-body">
              <a *ngIf="quote.quote_Converted==null" class="mobile-link" routerLink="/quote/{{quote.quote_ID}}">{{quote.quote_Name}} - #{{quote.quote_ProjectNumber}}</a>
              <a *ngIf="quote.quote_Converted" class="mobile-link" routerLink="/job/{{quote.quote_ID}}">{{quote.quote_Name}}</a>
              <app-quote-info-mobile [quoteInfo]="quote" [jobTypesList]="jobTypes"></app-quote-info-mobile>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Contacts">
      <div class="content">
        <div class="mt-3">
          <h4 class="d-inline col">{{customer.customer_BusinessName}}</h4>
          <button *ngIf="canEdit" class="d-inline btn btn-bidit-submit float-right" (click)="openContactDialog()">Add Contact</button>
        </div>
        <h5 class="col mb-3" i18n>Contacts</h5>

        <div *ngFor="let contact of customer.contacts">
          <div class="card border-bidit-dark bg-light mb-3 shadow">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="form-inline">
                    <span class="text-bidit-primary" i18n>Contact</span>
                  </div>
                  <div class="form-inline">
                    <a class="mobile-link" (click)="openContactDialog(contact)">{{contact.contact_FirstName}} {{contact.contact_LastName}}</a>
                  </div>
                </div>
                <div class="col-7">
                  <div class="form-inline">
                    <span class="text-bidit-primary" i18n>Work Phone:</span>
                    <span class="text-bidit-primary">{{contact.contact_Phone}}</span>
                  </div>
                  <div class="form-inline">
                    <span class="text-bidit-primary" i18n>Cell Phone:</span>
                    <span class="text-bidit-primary">{{contact.contact_Mobile}}</span>
                  </div>
                  <div class="form-inline">
                    <span class="text-bidit-primary" i18n>Email:</span>
                    <span id="mainContactName" class="text-bidit-primary">{{contact.contact_Email}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="noteLabel">
      <div class="content">
        <div class="mt-3">
          <h4 class="d-inline col">{{customer.customer_BusinessName}}</h4>
          <button *ngIf="canEdit" class="d-inline btn btn-bidit-submit float-right" (click)="editNote()" i18n>Add Note</button>
        </div>
        <h5 class="col mb-3" i18n>Notes</h5>
        <div *ngFor="let note of notes">
          <div class="card border-bidit-dark bg-light mb-3 shadow">
            <div class="card-body">
              <div class="row mb-2">
                <span class="col-8 text-bidit-primary-header">{{customer.customer_BusinessName}}</span>
                <div class="col-4">
                  <div class="float-right">
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-edit mr-2" (click)="editNote(note)"></button>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-delete" (click)="deleteNote(note)"></button>
                  </div>
                </div>
              </div>
              <p>
                <span>{{note.note_Text}}</span>
              </p>
              <div>
                <span class="text-bidit-primary"><span i18n>Created by</span> {{note.createdBy.firstName}} {{note.createdBy.lastName}} on {{note.note_Created | date: 'M/d/yyyy'}} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="documentLabel">
      <div class="content">
        <div class="mt-3">
          <h4 class="d-inline col">{{customer.customer_BusinessName}}</h4>
          <button *ngIf="canEdit" class="d-inline btn btn-bidit-submit float-right" (click)="editDocument()" i18n>Add Document</button>
        </div>
        <h5 class="col mb-3" i18n>Documents</h5>
        <div *ngFor="let document of documents">
          <div class="card border-bidit-dark bg-light mb-3 shadow">
            <div class="card-body">
              <div class="row mb-2">
                <span class="col-7 text-bidit-primary-header">{{customer.customer_BusinessName}}</span>
                <div class="col-5">
                  <div class="float-right">
                    <button *ngIf="document.note_Attachment" (click)="downloadAttachment(document)" class="btn btn-success mr-1" i18n>Download</button>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-edit mr-2" (click)="editDocument(document)"></button>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-delete" (click)="deleteNote(document)"></button>
                  </div>
                </div>
              </div>
              <p>
                <span>{{document.note_Text}}</span>
              </p>
              <p>
                <span><span i18n>File Name:</span> {{document.note_Text}}</span>
              </p>
              <div>
                <span class="text-bidit-primary"><span i18n>Created by</span> {{document.createdBy.firstName}} {{document.createdBy.lastName}} on {{document.note_Created | date: 'M/d/yyyy'}} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>

